/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from native/schemas/analytics/Analytics.yaml
import { ToJsonConfiguration } from '../common/JsonSerializationTypes';
/**
The feature that is being tracked.
*/
export class AnalyticsFeature {
    /** @param source {@displayType `DeepPartial<AnalyticsFeature>`} */
    constructor(source = {}) { }
    serialize(config = new ToJsonConfiguration()) {
        return {};
    }
}
(function (AnalyticsFeature) {
    /**
      The document scanner feature.
      
      Default is "rtuui_document_scanner"
      */
    AnalyticsFeature.documentScanner = 'rtuui_document_scanner';
})(AnalyticsFeature || (AnalyticsFeature = {}));
/**
The category that is being tracked.
*/
export class AnalyticsCategory {
    /** @param source {@displayType `DeepPartial<AnalyticsCategory>`} */
    constructor(source = {}) { }
    serialize(config = new ToJsonConfiguration()) {
        return {};
    }
}
(function (AnalyticsCategory) {
    /**
      The acknowledge category.
      
      Default is "acknowledge"
      */
    AnalyticsCategory.acknowledge = 'acknowledge';
})(AnalyticsCategory || (AnalyticsCategory = {}));
/**
The event that is being tracked.
*/
export class AnalyticsEvent {
    /** @param source {@displayType `DeepPartial<AnalyticsEvent>`} */
    constructor(source = {}) {
        /**
          The value associated with the event.
          */
        this.values = [];
        if (source.feature !== undefined) {
            this.feature = source.feature;
        }
        else {
            throw new Error('feature must be present in constructor argument');
        }
        if (source.category !== undefined) {
            this.category = source.category;
        }
        else {
            throw new Error('category must be present in constructor argument');
        }
        if (source.name !== undefined) {
            this.name = source.name;
        }
        else {
            throw new Error('name must be present in constructor argument');
        }
        if (source.values !== undefined) {
            this.values = source.values.map((it) => {
                return it;
            });
        }
    }
    serialize(config = new ToJsonConfiguration()) {
        return {
            feature: this.feature,
            category: this.category,
            name: this.name,
            values: this.values.map((it) => {
                return it;
            }),
        };
    }
}
/**
The name of the event.
*/
export class AnalyticsEventName {
    /** @param source {@displayType `DeepPartial<AnalyticsEventName>`} */
    constructor(source = {}) { }
    serialize(config = new ToJsonConfiguration()) {
        return {};
    }
}
(function (AnalyticsEventName) {
    /**
      The image quality result event for imported page.
      
      Default is "imported_image_quality_result"
      */
    AnalyticsEventName.importedImageQualityResult = 'imported_image_quality_result';
    /**
      The image quality result event for scanned page.
      
      Default is "scanned_image_quality_result"
      */
    AnalyticsEventName.scannedImageQualityResult = 'scanned_image_quality_result';
    /**
      The proceed event.
      
      Default is "proceed_with_image"
      */
    AnalyticsEventName.proceedImage = 'proceed_with_image';
    /**
      The retake event.
      
      Default is "retake_image"
      */
    AnalyticsEventName.retakeImage = 'retake_image';
})(AnalyticsEventName || (AnalyticsEventName = {}));
/**
A predefined analytics event.
*/
export class AnalyticsEventFactory {
    /** @param source {@displayType `DeepPartial<AnalyticsEventFactory>`} */
    constructor(source = {}) { }
    serialize(config = new ToJsonConfiguration()) {
        return {};
    }
}
(function (AnalyticsEventFactory) {
    /**
      A predefined analytics event.
      */
    AnalyticsEventFactory.scannedImageQualityResult = new AnalyticsEvent({
        feature: 'rtuui_document_scanner',
        category: 'acknowledge',
        name: 'scanned_image_quality_result',
    });
    /**
      A predefined analytics event.
      */
    AnalyticsEventFactory.importedImageQualityResult = new AnalyticsEvent({
        feature: 'rtuui_document_scanner',
        category: 'acknowledge',
        name: 'imported_image_quality_result',
    });
    /**
      A predefined analytics event.
      */
    AnalyticsEventFactory.proceedWithImage = new AnalyticsEvent({
        feature: 'rtuui_document_scanner',
        category: 'acknowledge',
        name: 'proceed_with_image',
    });
    /**
      A predefined analytics event.
      */
    AnalyticsEventFactory.retakeImage = new AnalyticsEvent({
        feature: 'rtuui_document_scanner',
        category: 'acknowledge',
        name: 'retake_image',
    });
})(AnalyticsEventFactory || (AnalyticsEventFactory = {}));
//# sourceMappingURL=Analytics.js.map